import React from 'react'
import { Input } from '@guillotinaweb/react-gmi'
import { useSetState } from 'react-use'
import { RichTextEditor } from './RichTextEditor'

const LANGS = ['es', 'en', 'fr', 'de', 'it']

const toDict = (list) =>
  list.reduce((b, x) => {
    b[x] = ''
    return b
  }, {})

export function I18NField({
  defaultLang,
  langs = LANGS,
  onChangeLang,
  onChange,
  vals = {},
  label,
  Widget = Input,
  children,
  modifyContent = true,
  placeholder,
}) {
  const initial = toDict(LANGS)

  const [values, setValues] = useSetState({ ...initial, ...vals })
  const [current, setCurrent] = React.useState(defaultLang || langs[0])
  const ref = React.useRef()

  const changeValue = (lang) => (ev) => {
    setValues({ [lang]: ev })
  }

  React.useEffect(() => {
    if (ref.current) {
      if (onChange) onChange(values)
    } else {
      ref.current = true
    }
  }, [values])

  const props = {
    placeholder: `${placeholder || 'Nombre'} ${current.toUpperCase()}`,
    value: values[current] || '',
    onChange: changeValue(current),
    className: 'is-size-6',
  }

  function changeLang(lang) {
    setCurrent(lang)
    if (onChangeLang) onChangeLang(lang)
  }

  return (
    <div className="field">
      <div className="label">{label}</div>
      <div className="field">
        <div className="tabs is-toggle" style={{ marginBottom: '0.5rem' }}>
          <ul style={{ marginLeft: 0 }}>
            {langs.map((item) => (
              <li
                className={'is-size-7 ' + (item === current ? 'is-active' : '')}
                key={item}
              >
                <a onClick={() => changeLang(item)}>{item.toUpperCase()}</a>
              </li>
            ))}
          </ul>
        </div>
        {modifyContent && <Widget {...props} />}
        {!modifyContent && <Input disabled={true} value={props.value} />}
        {typeof children === 'function' ? children(current) : children}
      </div>
    </div>
  )
}

export function I18NRichText({
  langs = LANGS,
  onChange,
  vals = {},
  label,
  id = '',
  modifyContent = true,
  editorProps = {},
}) {
  const initial = toDict(LANGS)

  const [values, setValues] = useSetState({ ...initial, ...vals })
  const [current, setCurrent] = React.useState(langs[0])
  const ref = React.useRef()

  const changeValue = (lang) => (ev) => {
    setValues({ [lang]: ev })
  }

  React.useEffect(() => {
    if (ref.current) {
      if (onChange) onChange(values)
    } else {
      ref.current = true
    }
  }, [values])

  return (
    <div className="field">
      {label && <div className="label">{label}</div>}
      <div className="field">
        <div className="tabs" style={{ marginBottom: '0.5rem' }}>
          <ul>
            {langs.map((item) => (
              <li
                className={'is-size-7 ' + (item === current ? 'is-active' : '')}
                key={item}
              >
                <a onClick={() => setCurrent(item)}>{item.toUpperCase()}</a>
              </li>
            ))}
          </ul>
        </div>
        {modifyContent && (
          <RichTextEditor
            key={current}
            id={`comment_${id}_${current}`}
            value={values[current] || ''}
            onChange={(content) => changeValue(current)(content)}
            height="200px"
            {...editorProps}
          />
        )}
        {!modifyContent && (
          <div
            dangerouslySetInnerHTML={{ __html: values[current] || '' }}
          ></div>
        )}
      </div>
    </div>
  )
}
